<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-multiple">
  <p class="loader-message">{{i18n._value['shp.helpcenter.case.pleaseWait']}}</p>
</ngx-spinner>

<div class="modal-body p-3" style="flex-wrap: initial;" *ngIf="this.questionField">
<div style="color: dodgerblue;" class="headingName" *ngIf="this.questionField">{{surveyDescription}}</div>
<span class="headingName" *ngIf="this.questionField">{{ticketLabel}} : </span><span class="fieldName"  *ngIf="this.questionField">{{ticketLabelParam}}</span>
<br>
<form #surveyform="ngForm" *ngIf="this.questionField!=''">
<div *ngFor="let surveyQuestion of this.questionField;let i= index">
 
  <div *ngIf="surveyQuestion.secondarySurveyType==='SINGLE_OPTION' && surveyQuestion.hideCheckBox==false">
    <label for="SINGLE_OPTION" class="fieldName">{{surveyQuestion.questionName}}</label><span style="color:red"
      *ngIf="surveyQuestion.required && !surveyQuestion.hideCheckBox">*</span>
   
      <div class="input-group">
    <div class="form-check form-check-inline" *ngIf="surveyQuestion.secondarySurveyType==='SINGLE_OPTION' && surveyQuestion.displayLayout=='HORIZONTALLY'">
        <label   *ngFor="let options of surveyQuestion.optionConfiguration">
          <input type="radio" id="SINGLE_OPTION" style="  margin: .4rem;padding-right: 50px!important;" class="form-check-input"  name="{{surveyQuestion.questionName}}" style="margin-left: 10px;" [required]="surveyQuestion.required && !options.optionHide"  
         [value]="options.optionName" [(ngModel)]="surveyQuestion.value"  *ngIf="!options.optionHide" #SINGLE_OPTION="ngModel"
        />
          <span *ngIf="!options.optionHide" class="fieldName" >{{options.optionName}}</span>
      </label> 
    </div>
  </div>
    
    
    <div *ngIf="surveyQuestion.secondarySurveyType==='SINGLE_OPTION' && surveyQuestion.displayLayout=='VERTICALLY'" >
        <div class="input-group" *ngFor="let options of surveyQuestion.optionConfiguration">
          <fieldset>
          <input type="radio"  style="margin: .4rem;padding-right: 50px!important;" name="{{surveyQuestion.questionName}}"  [required]="surveyQuestion.required && !options.optionHide"  #SINGLE_OPTION="ngModel"
         [value]="options.optionName" [(ngModel)]="surveyQuestion.value"  *ngIf="!options.optionHide"
        />
      </fieldset>
          <span *ngIf="!options.optionHide" class="fieldName">{{options.optionName}}</span>
      </div>
    </div>
  </div>

  <div class="form-group" *ngIf="surveyQuestion.secondarySurveyType==='TEXTAREA'&& !surveyQuestion.hideCheckBox">
    <label for="textareafield" class="fieldName">{{surveyQuestion.questionName}}</label><span style="color:red"
      *ngIf="surveyQuestion.required && !surveyQuestion.hideCheckBox">*</span>
   
    <div class="input-group">
      <textarea  [required]="surveyQuestion.required && !surveyQuestion.hideCheckBox" id="{{surveyQuestion.questionName}}" class="options_align" #textareafield="ngModel"
        name="{{surveyQuestion.questionName}}"  [(ngModel)]="surveyQuestion.value" value="surveyQuestion.value"
        required></textarea>
    </div>
    <div class="validation_style" *ngIf="surveyQuestion.required && textareafield.invalid && textareafield.touched">
      {{i18n._value['survey.answer']}} {{surveyQuestion.questionName}} </div>
  </div>

  <div class="form-group" *ngIf="surveyQuestion.secondarySurveyType==='PLAINTEXT' && surveyQuestion.hideCheckBox==false">
    <label for="PLAINTEXT" class="fieldName">{{surveyQuestion.questionName}}</label><span style="color:red"
      *ngIf="surveyQuestion.required && !surveyQuestion.hideCheckBox">*</span>
   
    <div class="input-group">
      <input type="text" class="options_align" [required]="surveyQuestion.required && !surveyQuestion.hideCheckBox" id="{{surveyQuestion.questionName}}" #PLAINTEXT="ngModel"
        name="{{surveyQuestion.questionName}}" [(ngModel)]="surveyQuestion.value" value ="surveyQuestion.value" 
       />
    </div>
    <div class="validation_style" *ngIf="surveyQuestion.required && PLAINTEXT.invalid  && PLAINTEXT.touched">
      {{i18n._value['survey.answer']}} {{surveyQuestion.questionName}}</div>
  </div>

  <div class="form-group" *ngIf="surveyQuestion.secondarySurveyType==='DROPDOWN' && !surveyQuestion.hideCheckBox">
    <label for="DROPDOWN" class="fieldName">{{surveyQuestion.questionName}}</label><span style="color:red"
      *ngIf="surveyQuestion.required && !surveyQuestion.hideCheckBox">*</span>
      <div class="input-group">
    <select [required]="surveyQuestion.required && !surveyQuestion.hideCheckBox" id="{{surveyQuestion.questionName}}" class="options_align" #DROPDOWN="ngModel"
    name="{{surveyQuestion.questionName}}" [(ngModel)]="surveyQuestion.value"  value="surveyQuestion.value" >
             <option value=""selected>Select a value</option> 
             <ng-container *ngFor="let options of surveyQuestion.optionConfiguration">
              <option  *ngIf ="!options.optionHide" [value]="options.optionName" class="fieldName" >
                {{options.optionName}}
              </option> 
            </ng-container>
            </select>
    </div>
    <div class="validation_style" *ngIf="surveyQuestion.required && DROPDOWN.invalid && DROPDOWN.touched">
      {{i18n._value['survey.answer']}} {{surveyQuestion.questionName}}</div>
  </div>

 <div class="form-group">
  <div *ngIf="surveyQuestion.secondarySurveyType==='MULIPLE_OPTION' && surveyQuestion.hideCheckBox==false && surveyQuestion.displayLayout=='VERTICALLY'">
    <label  for="surveyMultiSelectQuestions" class="fieldName" >{{surveyQuestion.questionName}}</label><span style="color:red"
      *ngIf="surveyQuestion.required && !surveyQuestion.hideCheckBox">*</span>
  
      <div  *ngIf="surveyQuestion.displayLayout=='VERTICALLY'">
      <div class="input-group" *ngFor="let options of surveyQuestion.optionConfiguration,let i=index">
      <input type='checkbox'   class="largerCheckbox"  style="margin:.4rem;padding-right: 50px!important;"  (change)="getOptionList($event,surveyQuestion.questionName)" [value]="options.optionName"   [required]="surveyQuestion.required && !surveyQuestion.hideCheckBox"
      *ngIf="!options.optionHide" required/>
        <span *ngIf="!options.optionHide"  class="fieldName" >{{options.optionName}}</span>
        </div>
    </div>
    <div class="validation_style" *ngIf="surveyQuestion.required && errorMsg && surveyQuestion.questionName==Errorname">
      {{i18n._value['survey.answer']}} {{surveyQuestion.questionName}}</div>
  </div>
  </div>
 <div *ngIf="surveyQuestion.secondarySurveyType==='MULIPLE_OPTION' && !surveyQuestion.hideCheckBox && surveyQuestion.displayLayout=='HORIZONTALLY'">
    <label  for="questionField" class="fieldName" >{{surveyQuestion.questionName}}</label><span style="color:red"
      *ngIf="surveyQuestion.required && !surveyQuestion.hideCheckBox">*</span>
      <div>
  <div class="form-check form-check-inline" *ngIf="surveyQuestion.secondarySurveyType==='MULIPLE_OPTION' && !surveyQuestion.hideCheckBox && surveyQuestion.displayLayout=='HORIZONTALLY'">
      <label  class="fieldName" *ngFor="let options of surveyQuestion.optionConfiguration">
        <input type='checkbox'   class="largerCheckbox"  style="margin:.4rem;padding-right: 50px!important;"  (change)="getOptionList($event,surveyQuestion.questionName)" [value]="options.optionName"   [required]="surveyQuestion.required && !surveyQuestion.hideCheckBox"
        *ngIf="!options.optionHide" required/>
        <span *ngIf="!options.optionHide" class="fieldName">{{options.optionName}}</span>&nbsp;
     
    </label>
  </div>
    </div>
    <div class="validation_style" *ngIf="surveyQuestion.required && errorMsg && surveyQuestion.questionName==Errorname">
      {{i18n._value['survey.answer']}} {{surveyQuestion.questionName}}</div>
    </div>
</div>

<br>
<span style="color:red;float: left;" class="fieldName" *ngIf="this.questionField">*</span><span>{{i18n._value['survey.confirm.required']}}</span>

<div class="modal-footer  d-flex justify-content-end">
  <button type="button"  (click)="handleNavigation()" *ngIf="this.defaultInstSurvey==true"  class="btn-warning btn m-1" rounded="true">{{i18n._value['survey.confirm.button.lable.close']}}</button>
  <button type="button" (click)="SaveSurvey(surveyform)"  class="btn-primary btn m-1"  [disabled]="!surveyform.valid"
    rounded="true" >{{i18n._value['survey.confirm.button.lable.submit']}}</button>
</div>
</form>
</div>
<ng-template #content let-modal style="align-content: center;">
    <div class="sticky">{{i18n._value['survey.confirm.header']}}
    </div>
    <div class="modal-body">
      <form #caseform="ngForm" class='form_class'>
     <div>
       <div style="font-weight: bold; text-align: center;">{{this.surveyName}}</div>
       <br>
<p style="text-align: center;" [innerHtml] = "i18n._value['survey.confirm.text']" > </p>
     </div>
        <div class="btn-align" *ngIf="this.defaultInstSurvey==true" >
          <button type="button" style="text-align: center;" (click)="handleNavigation()" class="btn-warning btn" rounded="true">{{i18n._value['survey.confirm.button.lable.close']}}</button> 
        </div>
        </form>
    </div>
</ng-template>  






 